import React from 'react';

const BecomingAgent = () => {
  return (
    <section id="getting-started" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl font-bold text-kiloterra-yellow mb-4 uppercase">
            Becoming a KILOTERRA Agent
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Watch this video to see what it's like to be a Land Specialist with KILOTERRA.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Vimeo Video Embed */}
          <div className="mb-12 animate-fade-in">
            <div 
              style={{padding: '56.25% 0 0 0', position: 'relative'}}
              className="rounded-lg overflow-hidden"
            >
              <iframe 
                src="https://player.vimeo.com/video/1118215814?badge=0&autopause=0&player_id=0&app_id=58479" 
                frameBorder="0" 
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} 
                title="AgentTestimonial_1080p_SITE"
              />
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomingAgent;